import { JSX } from 'react';
import {
    List,
    TextField,
    Datagrid,
    EditButton,
    DateField,
    FunctionField,
    SelectField
} from 'react-admin';

import { ContactForm } from "../../types/entities";

const formStatus: { id: string, name: string }[] = [
    { id: 'new', name: 'New' },
    { id: 'active', name: 'Active Conversation' },
    { id: 'dead', name: 'Failed to convert' },
    { id: 'customer', name: 'Converted to Customer' },
    { id: 'closed', name: 'Closed' },
];

export const ContactFormList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ false }
        >
            {/* HQ-22 asked why the Edit control here carries no permission check. It gates
                itself: react-admin asks `authProvider.canAccess` for the edit action on every
                `<EditButton>`, which answers against HQ_Sales::contact_forms. A second check in
                front of it would be the same rule written twice. */}
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <FunctionField
                    label="Name"
                    render={ (record: ContactForm): string => `${record.firstname} ${record.lastname}`}
                />
                <TextField source="email"  />
                <SelectField source="status" choices={ formStatus } />
                <DateField source="createdAt" showTime />
                <EditButton />
            </Datagrid>
        </List>
    );
}
